import { useHistory } from "react-router-dom";
import { useMemo, useState, useEffect } from "react";
import { Container, Aba, MobileDropdown, MobileCurrentTab, MobileDropdownMenu, MobileDropdownItem } from "./styles";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useAuth } from "../../../contexts/UserContext";

export default function AbasDemanda({ 
    id, 
    abaAtiva, 
    pendencias = 0,
    orientacoes = 0,
    comentarios = 0,
    anexos = 0,
    loading = false,
}: { id: number, abaAtiva: string, pendencias?: number, orientacoes?: number, comentarios?: number, anexos?: number, loading?: boolean}) {
    const history = useHistory();
    const { user } = useAuth();
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const podeVerHistorico = user?.profile === 'admin' || user?.profile === 'operador';

    const abas = useMemo(() => {
        const abasBase = [
            {
                label: 'Principal',
                count: 0,
                mostraCount: false,
                path: 'principal',
            },
            {
                label: 'Orientações',
                count: orientacoes,
                mostraCount: orientacoes > 0,
                path: 'orientacoes',
            },
            {
                label: 'Pendências',
                count: pendencias,
                mostraCount: pendencias > 0,
                path: 'pendencias',
            },
            {
                label: 'Comentários',
                count: comentarios,
                mostraCount: comentarios > 0,
                path: 'comentarios',
            },
            {
                label: 'Anexos',
                count: anexos,
                mostraCount: anexos > 0,
                path: 'anexos',
            },
        ];

        if (podeVerHistorico) {
            abasBase.push({
                label: 'Histórico',
                count: 0,
                mostraCount: false,
                path: 'historico',
            });
        }

        return abasBase;
    }, [pendencias, orientacoes, comentarios, anexos, podeVerHistorico])

    useEffect(() => {
        if (!loading && abaAtiva === 'historico' && !podeVerHistorico) {
            history.replace(`/demandas/${id}/principal`);
        }
    }, [abaAtiva, podeVerHistorico, id, history, loading]);

    const abaAtual = abas.find(aba => aba.path === abaAtiva) || abas[0];

    const handleTabClick = (path: string) => {
        history.replace(`/demandas/${id}/${path}`);
        setDropdownOpen(false);
    };

    if (loading) {
        return (
            <>
                {/* Desktop skeleton */}
                <Container>
                    {[1, 2, 3, 4, 5, 6].map((index) => (
                        <div key={index} style={{ padding: '16px 10px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <Skeleton height={16} width={80} />
                            <Skeleton height={20} width={24} borderRadius={6} />
                        </div>
                    ))}
                </Container>

                {/* Mobile skeleton */}
                <MobileDropdown>
                    <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'space-between', 
                        padding: '18px 20px',
                        background: 'var(--surface-card)',
                        borderRadius: '6px',
                        boxShadow: '0 0 2px rgba(0, 0, 0, 0.1)'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Skeleton height={16} width={100} />
                            <Skeleton height={20} width={24} borderRadius={12} />
                        </div>
                        <Skeleton height={18} width={18} />
                    </div>
                </MobileDropdown>
            </>
        );
    }

    return (
        <>
            {/* Desktop version */}
            <Container>
                {abas.map((aba) => (
                    <Aba 
                        abaAtiva={abaAtiva === aba.path}
                        key={aba.path} 
                        onClick={() => handleTabClick(aba.path)}
                        >
                        <span className="label">{aba.label}</span>
                        {aba.mostraCount && <span className="count">{aba.count}</span>}
                    </Aba>
                ))}
            </Container>

            {/* Mobile version */}
            <MobileDropdown>
                <MobileCurrentTab 
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                    isOpen={dropdownOpen}
                >
                    <div className="tab-info">
                        <span className="label">{abaAtual.label}</span>
                        {abaAtual.mostraCount && <span className="count">{abaAtual.count}</span>}
                    </div>
                    <svg className="chevron" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                </MobileCurrentTab>

                {dropdownOpen && (
                    <MobileDropdownMenu>
                        {abas.map((aba) => (
                            <MobileDropdownItem
                                key={aba.path}
                                isActive={abaAtiva === aba.path}
                                onClick={() => handleTabClick(aba.path)}
                            >
                                <span className="label">{aba.label}</span>
                                {aba.mostraCount && <span className="count">{aba.count}</span>}
                            </MobileDropdownItem>
                        ))}
                    </MobileDropdownMenu>
                )}
            </MobileDropdown>
        </>
    )
}